export function nowSec() {
  return Math.floor(Date.now() / 1000);
}

export function ageShort(tsSec) {
  if (!tsSec) return "";
  const d = nowSec() - tsSec;
  if (d < 0) return "now";
  if (d < 60) return `${d}s`;
  const m = Math.floor(d / 60);
  if (m < 60) return `${m}m`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h`;
  const days = Math.floor(h / 24);
  return `${days}d`;
}

export function withinRangeSec(tsSec, range) {
  if (!range || range === "all") return true;
  const n = nowSec();
  const d = n - tsSec;
  const map = {
    "1h": 3600,
    "4h": 4 * 3600,
    "24h": 24 * 3600,
    "7d": 7 * 24 * 3600,
    "30d": 30 * 24 * 3600,
  };
  const limit = map[range];
  if (!limit) return true;
  return d <= limit;
}

export function buildBaseKey(e) {
  const bull = !!e?.bull;
  const bear = !!e?.bear;
  const cur = (e?.cur || "").trim();
  if (!bull && !bear) return cur;
  if (bull && !bear) return cur + "|BULL";
  if (bear && !bull) return cur + "|BEAR";
  return cur + "|BULL|BEAR";
}

const LS_KEY = "insights_history_filters_v1";

export function loadFilters() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return { range: "24h", q: "", occ2: false };
    const v = JSON.parse(raw);
    return {
      range: v.range || "24h",
      q: v.q || "",
      occ2: !!v.occ2,
    };
  } catch {
    return { range: "24h", q: "", occ2: false };
  }
}

export function saveFilters(filters) {
  try {
    localStorage.setItem(LS_KEY, JSON.stringify(filters));
  } catch {}
}

/**
 * Tokenize a logical search query: "(reversal or grab) and DEGO" -> ["(", "reversal", "or", "grab", ")", "and", "DEGO"]
 */
function tokenizeLogicalQuery(q) {
  const s = (q || "")
    .replace(/\(/g, " ( ")
    .replace(/\)/g, " ) ")
    .trim();
  if (!s) return [];
  return s.split(/\s+/).filter(Boolean);
}

/**
 * Evaluate logical expression against haystack (case-insensitive).
 * Supports: terms (match if haystack contains term), "and", "or", parentheses.
 * AND has higher precedence than OR.
 * Returns true if expression matches (or if query is empty).
 */
export function matchLogicalQuery(query, haystack) {
  const raw = (query || "").trim();
  if (!raw) return true;
  const hay = (haystack || "").toLowerCase();
  const tokens = tokenizeLogicalQuery(raw);
  if (tokens.length === 0) return true;

  let pos = 0;
  const isOp = (t) => t && (t.toLowerCase() === "and" || t.toLowerCase() === "or");
  const isParen = (t) => t === "(" || t === ")";
  const isTerm = (t) => t && !isOp(t) && !isParen(t);

  function parseOr() {
    let left = parseAnd();
    while (pos < tokens.length && tokens[pos]?.toLowerCase() === "or") {
      pos++;
      const right = parseAnd();
      left = left || right;
    }
    return left;
  }

  function parseAnd() {
    let left = parsePrimary();
    while (pos < tokens.length && tokens[pos]?.toLowerCase() === "and") {
      pos++;
      const right = parsePrimary();
      left = left && right;
    }
    return left;
  }

  function parsePrimary() {
    if (pos >= tokens.length) return false;
    const t = tokens[pos];
    if (t === "(") {
      pos++;
      const inner = parseOr();
      if (pos < tokens.length && tokens[pos] === ")") pos++;
      return inner;
    }
    if (isTerm(t)) {
      pos++;
      return hay.includes(t.toLowerCase());
    }
    return false;
  }

  return parseOr();
}
